import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ role, allowed, children }) {
  const token = localStorage.getItem("token");

  // Se não estiver logado ou não tiver token → volta para login
  if (!role || !token) {
    return <Navigate to="/login" replace />;
  }

  // Se estiver logado mas não tiver permissão → redireciona conforme seu role
  if (!allowed.includes(role)) {
    if (role === "admin") return <Navigate to="/admin" replace />;
    if (role === "viewer") return <Navigate to="/admin" replace />; // ← NOVO
    return <Navigate to="/mapa" replace />;
  }

  return children;
}
